import React from 'react';

const LockIcon: React.FC = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.3333 14.668H6.66667C5.19391 14.668 4 15.8619 4 17.3346V26.668C4 28.1407 5.19391 29.3346 6.66667 29.3346H25.3333C26.8061 29.3346 28 28.1407 28 26.668V17.3346C28 15.8619 26.8061 14.668 25.3333 14.668Z"
      stroke="#A7A7A7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33203 14.668V9.33464C9.33203 7.56653 10.0344 5.87083 11.2847 4.62059C12.5349 3.37035 14.2306 2.66797 15.9987 2.66797C17.7668 2.66797 19.4625 3.37035 20.7127 4.62059C21.963 5.87083 22.6654 7.56653 22.6654 9.33464V14.668"
      stroke="#A7A7A7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LockIcon;
